"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTransitionWrapper = exports.StyledInputWrapper = exports.StyledFooterContainer = exports.StyledSelectContainer = exports.StyledTabWrapper = exports.StyledRegexButton = exports.StyledButtonsContainer = exports.StyledButton = exports.StyledSelectionTabContainer = exports.StyledCollapseTabContainer = exports.StyledBodyContainer = exports.StyledLeader = exports.StyledTitle = exports.StyledLevelSection = exports.StyledList = exports.StyledListStyleContainer = exports.StyledTabStyles = exports.StyledRotatedIconWrapper = exports.StyledIconWrapper = exports.StyledOptionMenuWrapper = exports.StyledHeader = exports.StyledAddHeaderContainer = exports.StyledHeaderContainer = exports.StyledContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledContainer = styled_components_1.default.div `
  display: block;
  position: relative;
  width: 296px;
  height: auto;
  padding: 0;
  border-radius: ${({ theme }) => theme.Border.Radius.Large}px;
  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  overflow: initial;
  box-shadow: 0px 0px 1.35596px 0px rgba(0, 0, 0, 0.05),
    0px 0px 3.25855px 0px rgba(0, 0, 0, 0.04),
    0px 0px 6.13556px 0px rgba(0, 0, 0, 0.03),
    0px 0px 10.94479px 0px rgba(0, 0, 0, 0.03),
    0px 0px 20.47103px 0px rgba(0, 0, 0, 0.02),
    0px 0px 49px 0px rgba(0, 0, 0, 0.01);
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Modal};
  cursor: default;
`;
exports.StyledHeaderContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.Modal.Margin.Small}px
    ${({ theme }) => theme.Modal.Padding.Large}px;
  border-bottom: 1px solid ${({ theme }) => theme.Color.Neutrals.Light};
`;
exports.StyledAddHeaderContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  justify-content: start;
`;
exports.StyledHeader = styled_components_1.default.div `
  display: flex;
  align-items: center;
  width: 100%;
`;
exports.StyledOptionMenuWrapper = styled_components_1.default.div ``;
exports.StyledIconWrapper = styled_components_1.default.div `
  display: flex;
  position: relative;
  gap: ${({ theme }) => theme.Modal.Padding.XSmall}px;
  margin-left: auto;
  cursor: pointer;
`;
exports.StyledRotatedIconWrapper = styled_components_1.default.div `
  display: flex;
  position: relative;
  margin-right: ${({ theme }) => theme.Modal.Margin.Small}px;
  transform: rotate(270deg);
`;
exports.StyledTabStyles = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 8px;
  column-gap: 8px;
  max-height: 173px;
  padding: ${({ theme }) => theme.Modal.Padding.Small}px
    ${({ theme }) => theme.Modal.Padding.Small}px 0px
    ${({ theme }) => theme.Modal.Padding.Small}px;
  margin-right: 4px;
  overflow: auto;
  scrollbar-gutter: stable;

  ${({ theme }) => {
    return theme.Scrollbar.Default;
}}

  ::-webkit-scrollbar-track {
    margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`} 0;
  }

  border-bottom: 1px solid ${({ theme }) => theme.Color.Neutrals.Light};
  padding-bottom: ${({ theme }) => theme.Modal.Padding.Small}px;
`;
exports.StyledListStyleContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.StyledList = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 80px;
  height: 70px;
  cursor: pointer;
  outline: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  border-radius: ${({ theme }) => theme.Border.Radius.Medium}px;
  padding-top: ${({ theme }) => theme.Modal.Padding.XSmall}px;
  transition: all ${({ theme }) => theme.Transition.Timing.Out};

  &:hover,
  &:active {
    background: ${({ theme }) => theme.Color.Brand.Lightest};
    color: ${({ theme }) => theme.Color.Brand.Primary};
    outline: 1px solid ${({ theme }) => theme.Color.Brand.Primary};
    transition: all ${({ theme }) => theme.Transition.Timing.In};
  }

  ${({ isSelected, theme }) => isSelected &&
    `
      color: ${theme.Color.Brand.Primary};
      outline: 1px solid ${theme.Color.Brand.Primary};
      transition: all ${theme.Transition.Timing.In};
    `};
`;
exports.StyledLevelSection = styled_components_1.default.section `
  display: flex;
  align-items: baseline;
  margin: 0px ${({ theme }) => theme.Modal.Margin.Medium}px 0px
    ${({ level, theme }) => 2 + level * theme.Modal.Margin.Small}px;
`;
exports.StyledTitle = styled_components_1.default.span `
  font-size: 9px;
  line-height: 12px;
  font-weight: 500;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-shadow: 0px 0px 1px rgba(255, 255, 255, 0.5);
`;
exports.StyledLeader = styled_components_1.default.span `
  line-height: 12px;
  font-weight: 500;
  letter-spacing: -3px;
  flex: 1;
  overflow: hidden;
  font-size: 8px;
  margin-left: ${({ theme }) => theme.Modal.Margin.XSmall}px;
  color: #bfcbda;
  min-width: 4.5px;
`;
exports.StyledBodyContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.Modal.Padding.Medium}px
    ${({ theme }) => theme.Modal.Padding.Large}px 0px
    ${({ theme }) => theme.Modal.Padding.Large}px;
  gap: 20px;
`;
exports.StyledCollapseTabContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.Modal.Padding.Large}px
    ${({ theme }) => theme.Modal.Padding.Large}px 0px
    ${({ theme }) => theme.Modal.Padding.Large}px;
  gap: ${({ theme }) => theme.Modal.Padding.Large}px;
`;
exports.StyledSelectionTabContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.Modal.Padding.Large}px;
  gap: ${({ theme }) => theme.Modal.Padding.XSmall}px;
`;
exports.StyledButton = styled_components_1.default.button `
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.Border.Radius.Medium}px;
  border: 1px solid transparent;
  cursor: pointer;
  display: inline-flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  ${ui_common_components_1.utils.getFontStyle('Body')}
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)} ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
  user-select: none;

  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  color: ${({ theme }) => theme.Color.Neutrals.Dark};
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};

  &:hover,
  &:active {
    background: ${({ theme }) => theme.Color.Brand.Lightest};
    border: 1px solid ${({ theme }) => theme.Color.Brand.Primary};
    color: ${({ theme }) => theme.Color.Brand.Primary};
  }

  ${({ isSelected, theme }) => isSelected &&
    `
    color: ${theme.Color.Brand.Primary};
    border: 1px solid ${theme.Color.Brand.Primary};
  `};

  &[disabled],
  &.disabled {
    background: ${({ theme }) => theme.Color.Neutrals.Paper};
    color: ${({ theme }) => theme.Color.Neutrals.Text};
    box-shadow: ${({ theme }) => `0 0 0 1px ${theme.Color.Neutrals.Text}`};
    pointer-events: none;
  }
`;
exports.StyledButtonsContainer = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => theme.Modal.Padding.Small}px;
`;
exports.StyledRegexButton = styled_components_1.default.button `
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.Border.Radius.Medium}px;
  border: 1px solid transparent;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${ui_common_components_1.utils.getFontStyle('Small')}
  min-width: 32px;
  min-height: 32px;
  user-select: none;

  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  color: ${({ theme }) => theme.Color.Neutrals.Dark};
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};

  &:hover,
  &:active {
    background: ${({ theme }) => theme.Color.Brand.Lightest};
    border: 1px solid ${({ theme }) => theme.Color.Brand.Primary};
    color: ${({ theme }) => theme.Color.Brand.Primary};
  }

  ${({ isSelected, theme }) => isSelected &&
    `
  color: ${theme.Color.Brand.Primary};
  border: 1px solid ${theme.Color.Brand.Primary};
`};

  &[disabled],
  &.disabled {
    background: ${({ theme }) => theme.Color.Neutrals.Paper};
    color: ${({ theme }) => theme.Color.Neutrals.Text};
    box-shadow: ${({ theme }) => `0 0 0 1px ${theme.Color.Neutrals.Text}`};
    pointer-events: none;
  }
`;
exports.StyledTabWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
exports.StyledSelectContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.Modal.Margin.XSmall}px;
  padding-bottom: ${({ theme }) => theme.Modal.Padding.Large}px;
`;
exports.StyledFooterContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin: 0px ${({ theme }) => theme.Modal.Padding.Large}px;
  padding: ${({ theme }) => theme.Modal.Padding.Large}px 0px;
  gap: ${({ theme }) => theme.Modal.Padding.Medium}px;
  border-top: 1px solid ${({ theme }) => theme.Color.Neutrals.Light};
`;
exports.StyledInputWrapper = styled_components_1.default.div `
  width: auto;
`;
exports.StyledTransitionWrapper = styled_components_1.default.div `
  position: relative;
  width: 100%;
  height: auto;
  padding: ${({ theme }) => theme.Modal.Margin.Small}px;
`;
//# sourceMappingURL=OrderedListMenu.style.js.map